import { render } from "./PasteButton.vue?vue&type=template&id=1feb71bd"
import script from "./PasteButton.vue?vue&type=script&lang=js"
export * from "./PasteButton.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__